import $ from 'jquery';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

/**
 * Scroll to anchor and update URL
 */
$(document).on('click', 'a[href*="#"]:not([href="#"])', function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var hash = this.hash;
        var target = $(hash);
        target = target.length ? target : $('[name=' + hash.slice(1) +']');
        if (target.length) {
			helpers.scrollToEl(target);
			helpers.addHashToURL(hash);
            return false;
        }
    }
});

/**
 * Add "scrolled" class to header on scroll.
 */
els.viewport.scroll(function() {
    var scroll = els.viewport.scrollTop();
    if(scroll > els.header.height()) {
        els.header.addClass("scrolled");
    } else {
        els.header.removeClass("scrolled");
    }
});

/**
 * initRemovePTags
 * Removes empty <p> elements from the DOM and removes <p> elements that are wrapped around an <img> element
 *
 * TO-DO: Update to remove all empty elements using this approach - https://tommcfarlin.com/remove-empty-html-tags/
 * TO-DO: Update using this approach - https://css-tricks.com/snippets/wordpress/remove-paragraph-tags-from-around-images/
 */
function initRemovePTags() {
	// Remove Empty <p> tags
	$('p:empty').remove();

	// Remove p tag wrap from image tags
	$('img').each(function() {
		var $this = $(this),
			$parent = $this.parents('p');

		if ($parent.text().length) {
			return;
		}

		if ($this.parent('a').length) {
			var $a = $this.parent();
			$a.addClass($this.attr('class'));
			$this.removeAttr('class');
			$this = $a;
		}

		$this.addClass($parent.attr('class'));
		$this.insertBefore($parent);
		$parent.remove();
	});
};

$(document).ready(function() {
	initRemovePTags();

	// Scroll to has if present
	if(window.location.hash) {
		helpers.scrollToEl($(window.location.hash));
	}

    $("a[href='#copyright']").replaceWith(function(){
        return $("<span>" + $(this).html() + "</span>");
    });

	$('.scroll-top').click(function() {
		$('html, body').animate({
			scrollTop: 0
		}, 500);
	});
});
